import _ from 'lodash';
import { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useNavigationType } from "react-router-dom";
import { NavLink } from "react-router-dom";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
} from "@mui/material";
import { Loading } from "@gpstrackit/react-controls"
import { useIntl } from "react-intl";

//Actions
import {
    accountsPromilesRequestOpenModal,
    generalSetTotalRecords,
    reportsOverviewGetData,
    executeReport,
    exportReport,
    clearRedux,
} from "Redux/actions";

//Components
import AdvancedFilters from 'Modules/reports/.components/AdvancedFilters';
import DataView from 'Components/DataView';
import ChipStatus from 'Components/ChipStatus';
import ChipBadge from 'Components/ChipBadge';
import moment from 'moment';
import { getDateFormatted, getQuery } from 'Core/data/Helpers';
import { NotificationManager } from "Components/Notifications";
import PromilesRequest from 'Modules/accounts/views/components/promilesRequest';

//Permission
import { HasPermission } from "Core/security"

//Styles
import './index.scss';

const REPORT_BATCH_SIZE = 50;
const DEFAULT_SUBMIT_ACTION = { intent: "execute", exportType: "CSV" };

const ReportOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const tableReport = useRef(null);

    let restrictedReports = ["fuelcards_recent_transactions_details"]

    const { loading, executeLoading, exportLoading, reportItems, nextToken: reportNextToken, total: reportTotal } = useSelector(state => state.reportOverviewRedux);
    const promilesRequestOpenModal = useSelector(state => state.promilesRequestRedux.openModal);
    const reportResult = useSelector(state => state.reportOverviewRedux.report);
    const excResult = useSelector(state => state.reportOverviewRedux.executeResult);
    const paramsResult = useSelector(state => state.reportOverviewRedux.params);
    const totalRecords = useSelector(state => state.generalRedux.totalRecords);
    const lang = useSelector(state => state.commonRedux.language);
    const user = useSelector(state => state.securityRedux.user);
    const reportExportResult = useSelector(state => state.reportOverviewRedux.exportResult);

    const { id } = useParams();

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const [values, setValues] = useState([]);
    const [valuesFormatted, setValuesFormatted] = useState(null);
    const [columns, setColumns] = useState([]);
    const [sortFields, setSortFields] = useState([])
    const [newReport, setNewReport] = useState(true);
    const [gridKey, setGridKey] = useState(moment().unix());
    const [orderBy, setOrderBy] = useState("");
    const [orderCriteria, setOrderCriteria] = useState("ASC");
    const [recreateGrid, setRecreateGrid] = useState(true);
    const [openPanel, setOpenPanel] = useState(false);
    const [report, setReport] = useState(null);
    const [params, setParams] = useState([]);
    const [conditions, setConditions] = useState([]);
    const [data, setData] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);
    const submitActionRef = useRef({ ...DEFAULT_SUBMIT_ACTION });
    const autoExecuteRef = useRef(false);

    const getColumns = (obj) => {

        let columns = [];
        let drillDowns = []
        let hiddenColumns = [];
        let dateColumns = [];

        if (report.properties && report.properties !== "" && report.properties.DrillDowns) {
            drillDowns = report.properties.DrillDowns;
        }
        if (report.properties && report.properties !== "" && report.properties.HiddenColumns)
            hiddenColumns = report.properties.HiddenColumns;

        if (report.properties && report.properties !== "" && report.properties.DateColumns)
            dateColumns = report.properties.DateColumns;

        let columnsNotShown = ["deviceId", "timezone"]
        let columnsLinkDevices = ["Label", "IMEI", "Serial", "ICCID"]
        let columnsLinkAccounts = ["Account", "companyName", "compName"]

        if (obj) {
            let keys = Object.keys(obj);
            let lessIndex = 0;
            if (keys.length > 0) {
                keys.forEach((item, index) => {
                    let dateTimeValues = ["lastMessageTime", "unitTime", "serverTime", "mostRecentMessageTime", "date", "created_date", "created_at", "updated_at", "transactionDate", "createdAt", "updatedAt", "dateProcessed", "startDateTime", "endDateTime", "initialRegistration", "lastRegistered", "lastMessageTime", "lastReportEvent", "eventDate"]
                    let dateValues = ["postDate", "created", "cardLastReceivedDate", "transLastReceivedDate", "lastTimeCreated", "createdDate"]
                    let reportTypeValues = ["devices_offline_bycompany", "sim", "devices_status_details", "devices_offline", "devices_without_heartbeat", "maintenance_warnings_summary", "maintenance_warnings_bytype", "devices_under_review"]
                    let drillDownItem = drillDowns.find(x => x.DrillDownColumn === item)
                    let hiddenItem = hiddenColumns.find(x => x === item)
                    let dateColumn = dateColumns.find(x => x === item)
                    console.log("item",item)
                    if (columnsNotShown.includes(item)) return

                    if (!hiddenItem) {
                        let title = item.replace(/\s/g, "");
                        title = `report_overview_${title}`
                        let colum = {
                            key: `${item}_${index}`,
                            field: item,
                            title: messages[title] || messages[item] || item,
                            show: true,
                            sort: reportTypeValues.includes(report.reportKey),
                            resize: true,
                            functionString: `
                                let statusList = ["SAVED", "INACTIVE", "ACTIVE", "sent", "pending"]
                                let currentTimezone = '${timeZone}'
                                let lang = "${lang}"

                                let dateFields = ["lastTimeCreated","created","cardLastReceivedDate","transLastReceivedDate","postDate", "createdDate"]
                                let dateTimeFields = ["createdAt","updatedAt","mostRecentMessageTime","date","lastMessageTime", "unitTime", "serverTime", "transactionDate", "dateProcessed", "startDateTime", "endDateTime", "eventDate"]

                                function formatDate(date,tz) {
                                    let dateToformat = moment(date)
                                    let formatted = moment(dateToformat).tz(tz).format("YYYY/MM/DD HH:mm:ss")
                                    return formatted;
                                }

                                function codes (type, lan){
                                    let listEn = {
                                        0: "Desactivated",
                                        1: "Active",
                                        2: "Voluntary Suspension",
                                        3: "Involuntary Suspension",
                                        4: "Cancelled",
                                        6: "RMA",
                                        20: "Inactive",
                                        SAVED: "Saved",
                                        INACTIVE: "Inactive",
                                        ACTIVE: "Active",
                                        sent: "Sent",
                                        pending: "Pending"
                                    }
                                    let listEs = {
                                        0: "Desactivado",
                                        1: "Activo",
                                        2: "Suspensión Voluntaria",
                                        3: "Suspensión Involuntaria",
                                        4: "Cancelado",
                                        6: "RMA",
                                        20: "Inactivo",
                                        SAVED: "Guardado",
                                        INACTIVE: "Inactivo",
                                        ACTIVE: "Activo",
                                        sent: "Enviado",
                                        pending: "Pendiente"
                                    }
                                    if(lan === "en"){
                                        return listEn[type] || listEn[1]
                                    } else {
                                        return listEs[type] || listEs[1]
                                    }
                                }
                                if (!isNaN(row['${item}']) && typeof row['${item}'] === 'number' && ${title.toLowerCase().includes("status")}) {
                                    return codes(row['${item}'], lang)
                                } else if (${title.toLowerCase().includes("status")} && statusList.includes(row['${item}'])){
                                    return codes(row['${item}'], lang)
                                } else if(dateFields.includes('${item}')){
                                    return row['${item}'] ? moment(row['${item}']).utc().format('YYYY/MM/DD') : ""
                                } else if(dateTimeFields.includes('${item}')){
                                    return row['${item}'] ? formatDate(row['${item}'],row?.timezone || currentTimezone) : ''
                                } else if('${item}' === 'cardNumber'){
                                    return "*"+ row['${item}'] + "*"
                                } else {
                                    return row['${item}'] || ''
                                }
                            `,
                            export: true,
                            width: 220,
                            code: title
                        };
                        //if there is a drilldown fos this column
                        if (drillDownItem) {

                            colum.render = (dataItem) => {
                                return (
                                    <Fragment>
                                        <a
                                            style={{
                                                textDecoration: "underline", cursor: "pointer"
                                            }}
                                            //to={`/app/reports/overview/-1`}
                                            onClick={() => {
                                                let reportsTotal = ["fuelcards_duplicates", "fuelcards_account_configuration"]
                                                let fieldTotal = ["numberTrans", "transactions_count"]
                                                if (drillDownItem.Type === "Overview") {
                                                    navigate(`/app${drillDownItem.Path}${dataItem[drillDownItem.IdCoumn]}`);
                                                } else {

                                                    let vals = [];//JSON.parse(JSON.stringify(values));
                                                    let valsFormatted = [];//JSON.parse(JSON.stringify(valuesFormatted));

                                                    //values = values.find(x => x.paramKey === "orderBy");
                                                    //values = values.find(x => x.paramKey === "orderCriteria");

                                                    //valuesFormatted = valuesFormatted.filter(x => x.paramKey !== "orderBy");
                                                    //valuesFormatted = valuesFormatted.filter(x => x.paramKey !== "orderCriteria");

                                                    drillDownItem.PassThroughColumns.map((item, index) => {
                                                        //
                                                        let valueItem = {} //values.find(x => x.paramKey = item.PassThroughColumn)
                                                        let valueItemIndex = vals.indexOf(valueItem);
                                                        valueItem.paramKey = item.PassThroughColumn;
                                                        //When paramvalue it's from a column
                                                        if (item.Column) {
                                                            valueItem.paramValue = dataItem[`${item.Column}`]
                                                            //When paramvalue it's defined on report properties
                                                        } else if (item.PassThroughColumnValue) {
                                                            valueItem.paramValue = item.PassThroughColumnValue;
                                                            //when paramvalue it's the same selected for the parent report
                                                        } else if (item.paramKey) {
                                                            let itemValue = values.find(x => x.paramKey === item.paramKey)
                                                            valueItem = itemValue;;
                                                        }

                                                        valueItem.id = valueItem.paramValue;

                                                        if (valueItem.paramKey === "accountId") {
                                                            if (item.PassThroughLabel)
                                                                valueItem.name = dataItem[item.PassThroughLabel];
                                                            else
                                                                valueItem.name = dataItem.Account;
                                                        }
                                                        if (valueItem.paramKey === "dealerId")
                                                            valueItem.name = dataItem.Dealer;
                                                        if (valueItem.paramKey === "unitStatus") {
                                                            let listItem = report.properties.DropDownLists.find(x => x.param === valueItem.paramKey).items.find(x => x.value === item.PassThroughColumnValue)
                                                            valueItem.label = (!messages[listItem.label] || messages[listItem.label] === "") ? listItem.label : messages[listItem.label];
                                                        }
                                                        vals.push(valueItem);

                                                        let valueItemFormatted = {}
                                                        valueItemFormatted.paramKey = item.PassThroughColumn;

                                                        valueItemFormatted.paramValue = item.Column ? dataItem[`${item.Column}`] : item.PassThroughColumnValue;
                                                        //When paramvalue it's from a column
                                                        if (item.Column) {
                                                            valueItemFormatted.paramValue = dataItem[`${item.Column}`]
                                                            //When paramvalue it's defined on report properties
                                                        } else if (item.PassThroughColumnValue) {
                                                            valueItemFormatted.paramValue = item.PassThroughColumnValue;
                                                            //when paramvalue it's the same selected for the parent report
                                                        } else if (item.paramKey) {
                                                            let itemValueFormatted = valuesFormatted.find(x => x.paramKey === item.paramKey)
                                                            valueItemFormatted = itemValueFormatted;;
                                                        }
                                                        valsFormatted.push(valueItemFormatted);
                                                    });

                                                    localStorage.setItem(`custom_${user.username}_${drillDownItem.ReportKey}_filter_reports_formatted`, JSON.stringify(valsFormatted));
                                                    localStorage.setItem(`custom_${user.username}_${drillDownItem.ReportKey}_filter_reports`, JSON.stringify(vals));

                                                    setNewReport(true);
                                                    setRecreateGrid(true);
                                                    localStorage.setItem(`custom_${user.username}_last_report_Id`, report.id)
                                                    if (reportsTotal.includes(report?.reportKey) && fieldTotal.includes(drillDownItem.DrillDownColumn)) {
                                                        dispatch(generalSetTotalRecords(dataItem[drillDownItem.DrillDownColumn]))
                                                    }
                                                    navigate(`/app/reports/overview/${drillDownItem.ReportKey}`)
                                                    loadNewReport(drillDownItem.ReportKey)
                                                }
                                            }}
                                        >
                                            {dataItem[drillDownItem.DrillDownColumn] || ''}
                                        </a>
                                    </Fragment>
                                )
                            };

                        } else if (dateTimeValues.includes(item) || dateValues.includes(item)) {
                            let dateFields = ["lastTimeCreated", "created", "cardLastReceivedDate", "transLastReceivedDate", "postDate", "createdDate"]
                            colum.render = (dataItem) => {
                                if (dateFields.includes(item)) {
                                    return <span>{dataItem[item] ? moment(dataItem[item]).utc().format('MMM DD YYYY') : ""}</span>
                                } else {
                                    return <span>{dataItem[item] && getDateFormatted(dataItem[item], "date", dateValues.includes(item) ? "date" : "datetime", null, dataItem?.timezone)}</span>
                                }
                            }
                        } else if (dateColumn) {
                            colum.render = (dataItem) => {
                                return <span>{dataItem[item] && getDateFormatted(dataItem[item], "long", "datetime")}</span>
                            }
                        } else if (item.toLowerCase().includes("status")) {
                            colum.render = (dataItem) => {
                                if (typeof dataItem[item] === "number")
                                    return <ChipStatus messages={messages} statusCode={dataItem[item]} />
                                else if (!dataItem[item] || dataItem[item] === "") {
                                    return <ChipBadge label={"NA"} status={dataItem[item]} />
                                } else {
                                    let label = messages[dataItem[item]] || dataItem[item]
                                    return <ChipBadge label={label} status={label} />
                                }
                            }
                        } else if (columnsLinkDevices.includes(item)) {
                            colum.render = (dataItem) => {
                                if (dataItem?.deviceId) {
                                    return (
                                        <NavLink to={`/app/devices/overview/${dataItem?.deviceId}`} style={{ color: 'black' }}>
                                            <span>{dataItem[item]}</span>
                                        </NavLink>
                                    )
                                } else {
                                    return <span>{dataItem[item]}</span>
                                }
                            }
                        } else if (columnsLinkAccounts.includes(item)) {
                            colum.render = (dataItem) => {
                                if (dataItem?.companyId) {
                                    return (
                                        <NavLink to={`/app/accounts/overview/${dataItem?.companyId}`} style={{ color: 'black' }}>
                                            <span>{dataItem[item]}</span>
                                        </NavLink>
                                    )
                                } else {
                                    return <span>{dataItem[item]}</span>
                                }
                            }
                        } else {
                            colum.render = (dataItem) => {
                                return <span>{dataItem[item]}</span>
                            }
                        }
                        columns.push(colum);
                    } else {
                        lessIndex++;
                    }
                })
            }
        }

        if (report.properties && report.properties !== "" && report.properties.ColumnActions) {
            report.properties.ColumnActions.map((item) => {
                let colum = {
                    key: `${item.Columnkey}`,
                    field: item.Columnkey,
                    title: "",
                    show: true,
                    resize: true,
                    width: 200,
                    render: (dataItem) => {
                        return (
                            <a
                                disabled={true}
                                style={{
                                    textDecoration: 'underline',
                                    color: HasPermission(user, "prmr", "u") ? '#0d6efd' : '#cdced0',
                                    cursor: HasPermission(user, "prmr", "u") ? 'pointer' : 'not-allowed'
                                }}
                                onClick={() => {
                                    if (HasPermission(user, "prmr", "u")) {
                                        dispatch(accountsPromilesRequestOpenModal(dataItem))
                                    }
                                }}
                            >
                                {messages[`report_overview_${item.ColumnLabel}`] || item.Columnkey}
                            </a>
                        )
                    }
                };
                if (columns.length) {
                    if (item?.Position === "start") columns.unshift(colum)
                    else columns.push(colum)
                }
            })
        }
        setColumns([...columns])
    }

    const loadNewReport = (id) => {

        //clear last report info
        dispatch(clearRedux("REPORTS_OVERVIEW"));

        //loadNewReport is only used for in-app drill-down/back navigation,
        //so it's the signal that the report should auto-execute once loaded
        autoExecuteRef.current = true;

        if (!_.isNaN(_.parseInt(id))) {
            dispatch(reportsOverviewGetData(id))
        } else {
            dispatch(reportsOverviewGetData(null, id));
        }
    }

    const executeReportCall = (reportId, reportParamsValues, reportParams, options = {}, rawValues = values, reportKey = report?.reportKey) => {
        const {
            newOrderBy,
            newOrderCriteria,
            nextToken = null,
            oldNextToken = null,
        } = options;
        let indexOrderBy = -1;
        let indexOrderCriteria = -1;
        let reportValues = Array.isArray(reportParamsValues) ? [...reportParamsValues] : [];

        if (newOrderBy && reportValues?.find(x => x.paramKey === "orderBy")) {
            let paramOrdeBy = reportValues.find(x => x.paramKey === "orderBy")
            indexOrderBy = reportValues.indexOf(paramOrdeBy);
            paramOrdeBy.paramValue = newOrderBy;
            reportValues[indexOrderBy] = paramOrdeBy;
        } else {
            let paramValueOrdeBy = reportValues?.find(x => x.paramKey === "orderBy");
            if (!paramValueOrdeBy && reportParams) {
                let param = reportParams.find(x => x?.param?.paramKey === "orderBy")
                if (param) {
                    paramValueOrdeBy = { paramKey: "orderBy", paramValue: param.defaultValue }
                    reportValues.push(paramValueOrdeBy);
                }
            }
        }
        if (newOrderCriteria && reportValues?.find(x => x.paramKey === "orderCriteria")) {
            let paramorderCriteria = reportValues?.find(x => x.paramKey === "orderCriteria")
            indexOrderCriteria = reportValues.indexOf(paramorderCriteria);
            paramorderCriteria.paramValue = newOrderCriteria;
            reportValues[indexOrderCriteria] = paramorderCriteria;
        } else {
            let paramValueorderCriteria = reportValues.find(x => x.paramKey === "orderCriteria")
            if (!paramValueorderCriteria && reportParams) {
                let param = reportParams.find(x => x?.param?.paramKey === "orderCriteria")
                if (param) {
                    paramValueorderCriteria = { paramKey: "orderCriteria", paramValue: param.defaultValue }
                    reportValues.push(paramValueorderCriteria);
                }
            }
        }

        if (!oldNextToken) {
            dispatch(clearRedux("REPORTS_OVERVIEW", { reportItems: [], nextToken: null, total: 0 }));
        }

        dispatch(executeReport(reportId, reportValues, REPORT_BATCH_SIZE, nextToken, oldNextToken));
        saveConditions(reportId, reportValues);
        tableReport?.current?.conditionsHandler({ id: reportId, values: reportValues, limit: REPORT_BATCH_SIZE, offset: 0 });

        const persistKey = reportKey || reportId;
        if (persistKey && user?.username) {
            localStorage.setItem(`custom_${user.username}_${persistKey}_filter_reports_formatted`, JSON.stringify(reportValues));
            localStorage.setItem(`custom_${user.username}_${persistKey}_filter_reports`, JSON.stringify(rawValues));
        }
        setValuesFormatted(reportValues)
        setHasSearched(true);
    }

    const saveConditions = (reportId, reportParamsValues) => {
        let conditions = {};
        let paramValues = [];
        reportParamsValues.map((item, key) => {
            let newItem = { paramValue: item.paramValue, paramKey: item.paramKey }
            paramValues.push(newItem)
        })
        conditions = {
            id: reportId,
            values: paramValues,
            limit: REPORT_BATCH_SIZE,
            offset: 0
        }
        setConditions(conditions);
    }

    const loadDataStart = (report, valuesFormatted, rawValues) => {
        setOpenPanel(false)
        executeReportCall(report.id, valuesFormatted, report.reportParams, {}, rawValues, report.reportKey)
    }

    const validateAndFormatParams = () => {
        let ready = true;
        let valuesLocal = values;
        let valuesFormatted = [];
        let message = "";
        for (let index in report.reportParams) {
            let reportParam = report.reportParams[index];
            reportParam.param = params.find(x => x.id === reportParam.paramId)
            if (!reportParam?.param?.paramKey) {
                continue;
            }
            let value = valuesLocal.find(x => x.paramKey === reportParam.param.paramKey);
            let valueFormatted = null;
            if (reportParam.required) {
                if (!value) {
                    if (!reportParam.defaultValue || reportParam.defaultValue === "") {
                        ready = false;
                        message = messages["report_overview_missing"] + " " + (messages[reportParam.param.name] || reportParam.param.name);
                        if (reportParam?.param?.name?.includes("Date Range")) {
                            message += messages['report_overview_select_calendar']
                        }
                        break;
                    } else {
                        valueFormatted = { paramValue: reportParam.defaultValue, paramKey: reportParam.param.paramKey }
                        valuesLocal.push({ paramValue: reportParam.defaultValue, paramKey: reportParam.param.paramKey })
                    }
                } else {
                    valueFormatted = { paramValue: value.paramValue, paramKey: value.paramKey }
                }
            } else {
                if (!value) {
                    valueFormatted = { paramValue: -1, paramKey: reportParam.param.paramKey }
                    valuesLocal.push({ paramValue: -1, paramKey: reportParam.param.paramKey })
                } else if (value.paramKey === "afterBeforeFlag" && value.paramValue && value.paramValue !== -1) {
                    let valueDate = valuesLocal.find(x => x.paramKey === "afterBeforeCreationDate");
                    if (!valueDate || !valueDate.paramValue) {
                        ready = false;
                        message = messages["report_overview_missing"] + " " + messages["report_overview_creation_date_filter"];
                        break;
                    }
                    valueFormatted = { paramValue: value.paramValue, paramKey: value.paramKey }
                } else {
                    valueFormatted = { paramValue: value.paramValue, paramKey: value.paramKey }
                }
            }

            //yyyy-mm-dd hh:mm:ss
            //YYYY-MM-DD HH:mm:ss

            if (reportParam.param.paramKey === "afterBeforeCreationDate" && valueFormatted.paramValue !== -1) {
                valueFormatted.paramValue = moment(valueFormatted.paramValue).utc().format("YYYY-MM-DD");
            } else if (reportParam.param.type === "Date" && valueFormatted.paramValue !== -1) {
                valueFormatted.paramValue = moment(valueFormatted.paramValue).utc().format("YYYY-MM-DD");
            } else if (reportParam.param.type === "DateTime" && valueFormatted.paramValue !== -1) {
                valueFormatted.paramValue = moment(valueFormatted.paramValue).utc().format("YYYY-MM-DD HH:mm:ss");
            } else if (reportParam.param.type === "DateRange" && valueFormatted.paramValue !== -1 && reportParam.param?.paramKey === "startDate") {
                let startDate = moment(valueFormatted.paramValue).set({ hour: 0, minute: 0, second: 0 }).utc().format("YYYY-MM-DD HH:mm:ss.sss");
                valueFormatted.paramValue = startDate;
            } else if (reportParam.param.type === "DateRange" && valueFormatted.paramValue !== -1 && reportParam.param?.paramKey === "endDate") {
                let endDate = moment(valueFormatted.paramValue).set({ hour: 23, minute: 59, second: 59 }).utc().format("YYYY-MM-DD HH:mm:ss.sss");
                valueFormatted.paramValue = endDate;
            }
            valuesFormatted.push(valueFormatted);
        }

        return { ready, valuesLocal, valuesFormatted, message, reportKey: report.reportKey };
    }

    const getNormalizedSubmitAction = (action = DEFAULT_SUBMIT_ACTION) => {
        return {
            intent: action?.intent === "export" ? "export" : "execute",
            exportType: action?.exportType || "CSV",
        };
    }

    const requestSubmitAction = (intent = "execute", exportType = "CSV") => {
        submitActionRef.current = getNormalizedSubmitAction({ intent, exportType });
    }

    const dispatchExportReportCall = (reportParamsValues, reportKey, exportType = "CSV") => {
        let limit = reportKey === "video_review_bycompany_v2" ? 5000 : null;

        dispatch(exportReport(
            report.id,
            reportParamsValues,
            exportType,
            report.properties,
            timeZone,
            lang,
            messages,
            report.name,
            limit
        ));
    }

    const onValidSubmit = () => {
        if (tableReport?.current) {
            //tableReport.current.setPaggingProps(1, 10);
        }

        const { intent: currentIntent, exportType: currentExportType } = getNormalizedSubmitAction(submitActionRef.current);
        const { ready, valuesLocal, valuesFormatted, message, reportKey } = validateAndFormatParams();

        if (ready) {
            if (currentIntent === "export") {
                dispatchExportReportCall(valuesFormatted, reportKey, currentExportType);
            } else {
                setValues(valuesLocal);
                setValuesFormatted(valuesFormatted);
                executeReportCall(report.id, valuesFormatted, report.reportParams, {}, valuesLocal, report.reportKey);
            }
        } else {
            NotificationManager.error(
                message,
                messages["report_overview_name"],
                3000,
                null,
                null,
                'error'
            );
        }

        submitActionRef.current = { ...DEFAULT_SUBMIT_ACTION };
    }

    const onExportReport = (exportType) => {
        const { ready, valuesFormatted, message, reportKey } = validateAndFormatParams();

        if (!ready) {
            NotificationManager.error(
                message,
                messages["report_overview_name"],
                3000,
                null,
                null,
                'error'
            );
            return;
        }

        dispatchExportReportCall(valuesFormatted, reportKey, exportType);
    }

    useEffect(() => {
        if (!_.isNaN(_.parseInt(id))) {
            dispatch(reportsOverviewGetData(id))
        } else {
            dispatch(reportsOverviewGetData(null, id));
        }
        return () => {
            dispatch(clearRedux("REPORTS_OVERVIEW"));
        }
    }, []);

    useEffect(() => {
        if (reportResult) {
            dispatch(clearRedux("REPORTS_OVERVIEW", { report: null }));
            let rprt = reportResult;

            const isBackNavigation = autoExecuteRef.current || navigationType === "POP";

            let filters = null;
            let valuesFormatted = null;

            if (isBackNavigation) {
                filters = localStorage.getItem(`custom_${user.username}_${rprt.reportKey}_filter_reports`);
                valuesFormatted = localStorage.getItem(`custom_${user.username}_${rprt.reportKey}_filter_reports_formatted`);

                if (!filters)
                    filters = localStorage.getItem(`custom_${user.username}_${rprt.id}_filter_reports`);

                if (typeof filters === "string")
                    filters = JSON.parse(filters)

                if (!valuesFormatted)
                    valuesFormatted = localStorage.getItem(`custom_${user.username}_${rprt.id}_filter_reports_formatted`);

                if (typeof valuesFormatted === "string")
                    valuesFormatted = JSON.parse(valuesFormatted)
            }

            //format the items for the DropDownList
            if (rprt.properties && rprt.properties.DropDownLists && rprt.properties.DropDownLists.length > 0) {
                rprt.properties.DropDownLists.map((list, indexList) => {
                    return list.items.map((item, index) => {
                        item.label = (!messages[item.label] || messages[item.label] === "") ? item.label : messages[item.label];
                        item.id = item.value;
                        return item;
                    });
                });
            }

            setReport(rprt)
            setValues(filters || []);
            setValuesFormatted(valuesFormatted || []);
            setNewReport(false);
            setHasSearched(false);

            if (isBackNavigation && valuesFormatted && valuesFormatted.length > 0) {
                loadDataStart(rprt, valuesFormatted, filters || []);
            } else {
                setOpenPanel(true);
            }
            autoExecuteRef.current = false;
        }
        if (excResult) {
            const { result, error } = excResult;

            dispatch(clearRedux("REPORTS_OVERVIEW", { executeResult: null }))

            if (!error) {
                let columns = [];
                let sortFields = [];
                if (result && result.reportData && result.reportData.items) {
                    let obj = result.reportData.items[0];
                    if (recreateGrid) {
                        setData(obj)
                        getColumns(obj);
                    }
                    setOpenPanel(false);
                }
            }
            else {
                const errorMessage = (error?.error || error?.message || `${error}` || "").replace("GraphQL error: ", "");
                NotificationManager.error(
                    errorMessage,
                    messages["report_overview_title"],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
        }
    }, [reportResult, excResult]);

    useEffect(() => {
        if (paramsResult) {
            setParams(paramsResult);
        }
    }, [paramsResult]);

    useEffect(() => {
        if (reportExportResult?.error) {
            NotificationManager.error(
                reportExportResult.error.message || "Export failed",
                messages["report_overview_name"],
                3000,
                null,
                null,
                'error'
            );
            dispatch(clearRedux("REPORTS_OVERVIEW", { exportResult: null }));
        }
    }, [reportExportResult]);

    useEffect(() => {
        if (lang && data) {
            getColumns(data)
        }
    }, [lang])

    return (
        <Container maxWidth={false} className="container-view">
            {(loading || executeLoading || exportLoading) && <Loading overlay show />}
            <Paper elevation={0} style={{ overflow: "auto" }}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95vh' }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={8}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton
                                        onClick={() => {
                                            if (!_.isNaN(_.parseInt(id))) {
                                                navigate(-1);
                                            } else {
                                                navigate(-1);
                                                setTimeout(function () {

                                                    let lastReportId = localStorage.getItem(`custom_${user.username}_last_report_Id`);
                                                    localStorage.removeItem(`custom_${user.username}_last_report_Id`);
                                                    loadNewReport(lastReportId)
                                                }, 500);
                                            }
                                        }
                                        }
                                        size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['report_overview_title']}:</span> {report?.name || ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>

                        {
                            hasSearched ? (
                                <Grid item xs={12} style={{ marginTop: 15 }} className="container-pm-reports">
                                    <DataView
                                        key={gridKey}
                                        exportName={`Report_${report.name}_${gridKey}`}
                                        ref={tableReport}
                                        name={`${gridKey}-v2`}
                                        onKeyChange={() => {
                                            setGridKey(moment().unix());
                                        }}
                                        height='calc(100vh - 190px)'
                                        externalData={reportItems || []}
                                        externalDataTotal={restrictedReports.includes(report?.reportKey) ? totalRecords : reportTotal || 0}
                                        externalLoading={executeLoading}
                                        infiniteScroll
                                        nextToken={reportNextToken}
                                        externalRefresh={() => {
                                            executeReportCall(report.id, valuesFormatted, report.reportParams, {
                                                newOrderBy: orderBy || null,
                                                newOrderCriteria: orderCriteria,
                                            })
                                        }}
                                        disableItemSelection
                                        noTags
                                        noSearch
                                        noSplit
                                        onFilters={() => {
                                            setOpenPanel(!openPanel);
                                        }}
                                        noExcel
                                        noPreferences
                                        messages={messages}
                                        columns={columns}
                                        sortFields={sortFields}
                                        onExternalSorting={(sort) => {
                                            let currentSort = sort.key.split("_")
                                            let order = sort?.order?.toUpperCase() || orderCriteria;
                                            setOrderBy(currentSort[0] || orderBy);
                                            setOrderCriteria(order);
                                            executeReportCall(report.id, valuesFormatted, report.reportParams, {
                                                newOrderBy: currentSort[0] || orderBy,
                                                newOrderCriteria: order,
                                            })
                                        }}
                                        onChangePage={(nextToken, page) => {
                                            if (!reportNextToken || executeLoading) return;
                                            executeReportCall(report.id, valuesFormatted, report.reportParams, {
                                                newOrderBy: orderBy || null,
                                                newOrderCriteria: orderCriteria,
                                                nextToken: reportNextToken,
                                                oldNextToken: reportNextToken,
                                            })
                                        }}
                                        isDynamo
                                        query={getQuery("report")}
                                        tableButtons={['export']}
                                        conditions={conditions}
                                        onChangeColumns={(items) => setColumns(items)}
                                    />
                                </Grid>
                            ) : (
                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                    <p style={{ textAlign: 'center', fontSize: 14, opacity: 0.6 }}>{messages['report_overview_select_filter']}</p>
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
            </Paper>
            {
                !restrictedReports.includes(report?.reportKey) &&
                <AdvancedFilters
                    setOpenPanel={setOpenPanel}
                    openPanel={openPanel}
                    tableRef={tableReport}
                    report={report}
                    params={params}
                    values={values}
                    setValues={setValues}
                    setRecreateGrid={setRecreateGrid}
                    onValidSubmit={onValidSubmit}
                    onExportReport={onExportReport}
                    onRequestSubmitAction={requestSubmitAction}
                    exportLoading={exportLoading}
                />
            }
            {promilesRequestOpenModal && <PromilesRequest />}
        </Container>
    );
}
export default ReportOverview;